import { Component, EventEmitter, Inject, Input, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ClassEnrolment, EnrolmentStatus } from '../../../models/class-enrolment.model';
import { CourseService } from '../../../services/course/course.service';
import { emailValidatorPattern, phoneValidatorPattern } from '../../../utils/validators.util';

@Component({
    selector: 'app-enrolment-learner',
    templateUrl: './enrolment-learner.component.html',
    styleUrls: ['./enrolment-learner.component.scss'],
    standalone: false
})
export class EnrolmentLearnerComponent {
  ENROLSTATUS = EnrolmentStatus;
  enrolmentForm: FormGroup;
  enrolmentDto: ClassEnrolment;
  @Input() set Enrolment(v: ClassEnrolment) {
    this.enrolmentDto = v;

    this.enrolmentForm = new FormGroup({
      emailAddress: new FormControl(this.enrolmentDto.EmailAddress, [Validators.pattern(emailValidatorPattern)]),
      phone: new FormControl(this.enrolmentDto.Phone, [Validators.pattern(phoneValidatorPattern)]),
      firstName: new FormControl(this.enrolmentDto.FirstName, [Validators.required]),
      lastName: new FormControl(this.enrolmentDto.LastName, [Validators.required]),
      birthYear: new FormControl(this.enrolmentDto.BirthYear, [Validators.required]),
      address: new FormControl(this.enrolmentDto.Address),
      note: new FormControl(this.enrolmentDto.NoteToProvider)
    });
    this.enrolmentUpdated.emit({ invalid: this.enrolmentForm.invalid, enrolment: this.enrolmentDto });
  }
  @Output() enrolmentUpdated = new EventEmitter<{ invalid: boolean, enrolment: ClassEnrolment }>();

  constructor(@Inject('CourseService') public courseService: CourseService) { }
   
  checkEmail() {
    if (!this.enrolmentForm.controls['emailAddress'].invalid) {
      this.enrolmentDto.EmailAddress = this.enrolmentForm.controls["emailAddress"].value;

      this.courseService.IsEmailExistInCourse(this.enrolmentDto).subscribe((b: boolean) => {
        this.enrolmentForm.controls['emailAddress'].setErrors(b ? { exists: true } : null);
        this.update();
      });
    } else this.update();
  }

  update() {
    this.enrolmentDto.EmailAddress = this.enrolmentForm.controls["emailAddress"].value;
    this.enrolmentDto.FirstName = this.enrolmentForm.controls["firstName"].value;
    this.enrolmentDto.LastName = this.enrolmentForm.controls["lastName"].value;
    this.enrolmentDto.Phone = this.enrolmentForm.controls["phone"].value;
    this.enrolmentDto.BirthYear = this.enrolmentForm.controls["birthYear"].value;
    this.enrolmentDto.Address = this.enrolmentForm.controls["address"].value;
    this.enrolmentDto.NoteToProvider = this.enrolmentForm.controls["note"].value;
    this.enrolmentUpdated.emit({ invalid: this.enrolmentForm.invalid, enrolment: this.enrolmentDto });
  }
}
